import { IContractEmailsRepository } from 'modules/customer/domain/repositories';
import { makeHTTPProvider } from 'shared/infra/providers';

import VectisContractEmailsRepository from './implementations/VectisContractEmailsRepository';

let instance: IContractEmailsRepository | null = null;

export default function makeContractPaymentsRepository() {
  if (!instance) {
    const httpProvider = makeHTTPProvider();

    instance = new VectisContractEmailsRepository(httpProvider);
  }

  return instance;
}
